export var DEFAULT_ICON_LIKED = 'heart';
export var DEFAULT_ICON_UNLIKED = 'heart outline';
export var DEFAULT_ICON_COLOR = 'red';
export var FEEDBACK_ERROR_MESSAGE = 'Could not complete request.';
export var FEEDBACK_POPUP_DURATION = 2000;